import { Component, Input } from '@angular/core';

export type FinancialInfoChartBar = {
  title: string;
  amount: number;
  currency: string;
  height: number;
};
@Component({
  selector: 'mfp-chart-bar',
  templateUrl: './chart-bar.component.html',
  styleUrls: ['./chart-bar.component.scss']
})
export class ChartBarComponent {
  @Input() x = '';
  @Input() amount = 0;
  @Input() currency = '';
  @Input() height = 0;
  @Input() style: 'dark' | 'light' = 'dark';

  constructor() {}
}
